import type { IUpdateLocationGeneralSettingsCmd } from "@/data/commands/location/UpdateLocationGeneralSettingsCmd";
import { Factory } from "@/data/dao/Factory";
import { LocationDao } from "@/data/dao/service/LocationDao";
import type { ILocationDetail } from "@/data/model/Location";
import { Validation } from "@/data/util/Validation";



import { i18n } from "@/portal/Trans";
import { TimePicker } from "@/portal/formControls/TimePicker";
import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";


export class LocationGeneralSettingsForm extends BaseEntityForm<ILocationDetail, IUpdateLocationGeneralSettingsCmd> {
    private $stockReceiverField: JQuery;
    private $pendingTableReservationReceiverField: JQuery;
    private $dailyOrderIncrementStartField: JQuery;
    private shiftStartInput: TimePicker;

    constructor(element: JQuery) {
        super(element, {
            getSingle: undefined as any,
            create: undefined as any,
            getData: undefined as any,
            remove: undefined as any,
            update: (i, d) => Factory.getInstance<LocationDao>(LocationDao).setGeneralSettings(i, d),
        });

        this.$stockReceiverField = this.$form.find('input[name="stockreceiver"]');
        this.$pendingTableReservationReceiverField = this.$form.find('input[name="pending-table-reservation-receiver"]');

        this.shiftStartInput = TimePicker.createFromInput(this.$form.find('input[name="shiftstart"]'), {
            maxHours: 24,
            showSeconds: false,
        });

        this.$dailyOrderIncrementStartField = this.$form.find('input[name="dailyorderincrementstart"]');
    }

    public setFormData(model?: ILocationDetail) {
        this.$stockReceiverField.val(
            (model!.generalSettings?.stockReceiver === undefined
                ? undefined
                : model!.generalSettings.stockReceiver) as any
        );

        this.$pendingTableReservationReceiverField.val(
            (model!.generalSettings?.stockReceiver === undefined
                ? undefined
                : model!.generalSettings.pendingTableReservationReceiver) as any
        );
        this.$dailyOrderIncrementStartField.val(
            (model?.generalSettings?.dailyOrderIncrementStart === undefined
                ? undefined
                : model.generalSettings.dailyOrderIncrementStart) as any
        );
        this.shiftStartInput.setValue(
            model?.generalSettings?.shiftStart === undefined ? undefined : model.generalSettings.shiftStart
        );

        this.updateName(
            model === undefined || model.privacySettings === undefined
                ? ""
                : model.name + " " + i18n("location.covidContactTracing")
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public getFormData($form: JQuery): IUpdateLocationGeneralSettingsCmd {
        const data: IUpdateLocationGeneralSettingsCmd = {
            shiftStart: this.shiftStartInput.getValue(),
            dailyOrderIncrementStart:
                this.$dailyOrderIncrementStartField.val().length === 0
                    ? undefined
                    : parseInt(this.$dailyOrderIncrementStartField.val()),
            stockReceiver: this.$stockReceiverField.val().length === 0 ? undefined : this.$stockReceiverField.val(),
            pendingTableReservationReceiver: this.$pendingTableReservationReceiverField.val().length === 0 ? undefined : this.$pendingTableReservationReceiverField.val(),
        };

        let hasError = false;
        this.$form.find(".is-invalid").removeClass("is-invalid");

        if (data.stockReceiver !== undefined && !Validation.isEmail(data.stockReceiver)) {
            this.$stockReceiverField.addClass("is-invalid");
            hasError = true;
        }

        if (
            data.dailyOrderIncrementStart !== undefined &&
            (isNaN(data.dailyOrderIncrementStart) || data.dailyOrderIncrementStart <= 0)
        ) {
            this.$dailyOrderIncrementStartField.addClass("is-invalid");
            hasError = true;
        }

        return (hasError ? undefined : data) as any;
    }
}
